import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    "@keyframes onloadup": {
        "0%": {
            opacity: 0,
        },
        "100%": {
            opacity: 1,
        }
    },
    settingsContainer: {
        background: '#F5F5F5',
        color: '#4a4a4a',
        fontSize: 16,
        letterSpacing: '-0.5px',
        height: '100%',
        padding: '34px 35px',
        animationName: `$onloadup`,
        animationDuration: '0.3s',
        animationFillMode: 'both',
        animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
        '@media(max-width: 1200px)': {
            paddingLeft: 110,
        },
        '@media(max-width: 768px)': {
            padding: 30,
        },
        '@media(max-width: 480px)': {
            padding: 20,
        }
    },
    settingsSection: {
        maxWidth: '1110px',
        position: 'relative',
        height: '100%'
    },
    settingsSectionContainer: {
        display: 'grid',
        marginBottom: 30,
        gridTemplateColumns: '48.5% 48.5%',
        gridColumnGap: '3%',
        '@media(max-width: 940px)': {
            display: 'block',
        },
    },
    settingsSectionContainerMain: {
        marginBottom: 0
    },
    settingsSectionContainerFirst: {
        gridTemplateColumns: '100%'
    },
    settingsSectionContainerSecond: {
        gridTemplateColumns: '100%',
        gridTemplateRows: '70%'
    },
    settingsSectionHeader: {
        lineHeight: '28px',
        marginBottom: 22
    },
    formSectionCopy: {
        marginBottom: 20,
        fontSize: '15px',
        color: '#a4a4a4'
    },
    settingsSectionContentCls: {
        background: '#FFF',
        border: '1px solid #E8E8E8',
        position: 'relative',
        padding: 30,
        '@media(max-width: 1024px)': {
            padding: 25,
        },
        '@media(max-width: 940px)': {
            marginBottom: 30,
            '&:last-child': {
                marginBottom: 0
            },
        },
        '@media(max-width: 768px)': {
            padding: 20,
        },
        height: 'fit-content'
    },
    settingsRightSectionContentCls:{
        height:'fit-content!important', 
    },
    settingsForm: {
        width: '100%',
    },
    settingsFormSection: {
        marginBottom: 25,
        '&:last-child': {
            marginBottom: 0
        },
        '& .MuiFormControl-root:nth-child(2)': {
            '& .MuiChip-root': {
                '& .MuiChip-icon': {
                    height: '18px',
                    width: '18px',
                }
            }
        },
        '& .MuiChip-deleteIcon': {
            height: '18px',
            width: '18px'
        },
        '& .MuiAutocomplete-clearIndicator': {
            '& .MuiSvgIcon-root': {
                height: '18px',
                width: '18px'
            }
        }
    },
    formSection: {
        marginBottom: 25,
        '&:last-child': {
            marginBottom: 0
        }
    },
    formSectionContent: {
        marginTop: 20,

    },
    editAddressLink: {
        padding: '0px'
    },
    changePasswordLink: {
        marginTop: 5,
        padding: '0px'
    },
    countrySelect: {

    },
    formSectionHeader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            alignItems: 'flex-start',
            flexDirection: 'column'
        }
    },
    formSectionHeading: {
        fontWeight: 500
    },
    formSectionInput: {
        marginBottom: 25,
        width: '100%',
        '@media(max-width: 480px)': {
            marginBottom: 20,
        },
        '&:last-child': {
            marginBottom: 0
        }
    },
    currentPasswordInput: {
        marginBottom: 0
    },
    formSectionCheckbox: {
        color: '#4A4A4A',
        display: 'flex',
        flexDirection: 'row',
        '& .MuiSvgIcon-root': {
            // fill: theme.palette.primary.main,
            // fontSize: '2.6rem'
            padding: 0,
            marginRight: '0px'
        },
        '& .MuiFormControlLabel-root': {
            margin: '0 10px 0 0',
            padding: 0,
            alignItems: 'flex-start',
            '& .MuiCheckbox-root': {
                padding: '0'
            }
        },
        '& ul': {
            paddingLeft: 0,
        },
        '& li': {
            listStyle: 'none',
            marginBottom: 8,
            '&:last-child': {
                marginBottom: 0
            }
        }
    },
    summaryContent: {
        backgroundColor: '#F5F5F5',
        display: 'block',
        marginTop: 25,
        padding: 30,
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            padding: 15
        }
    },
    summaryItem: {
        marginBottom: 30,
        '&:last-child': {
            marginBottom: 0
        },
        [theme.breakpoints.down('md')]: {
            marginBottom: 10,
            width: 'auto'
        }
    },
    summaryItemLabel: {
        color: '#A4A4A4',
        display: 'block',
        fontSize: 14
    },
    summaryItemValue: {
        color: '#4A4A4A',
        display: 'block',
        fontSize: 16,
        fontWeight: 500,
        marginRight: 20,
        wordBreak: 'break-word',
        fontFamily: 'CircularStd',
        lineHeight: '1.5'
    },
    settingsButtons: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 30
    },
    settingsButton: {
        width: 200,
        [theme.breakpoints.down('md')]: {
            marginBottom: 10,
            width: '100%'
        }
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
    manualInput: {
        width: '100%',
        marginBottom: 25,
        '&:last-child': {
            marginBottom: 0
        }
    },
    itemIcon: {
        height: 18,
        marginRight: 5,
        position: 'relative',
        top: '4px',
    },
    emailPreferenceCheckboxSection: {
        '& .MuiSvgIcon-root': {
            padding: 0,
            marginRight: 0
        },
        '& .MuiFormControlLabel-root': {
            margin: '0 0 10px 0',
            padding: '0 20px 0 0',
            alignItems: 'flex-start',
            '& .MuiFormControlLabel-root': {
                margin: '0 10px 0 0',
                padding: 0
            },
            '& .MuiCheckbox-root': {
                padding: 0
            }
        },
    }
});